export default __webpack_public_path__ + "static/media/points.1969be97.svg";